export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "move_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mover"])},
          "clone_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duplicar"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}